import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {COOKIE_EXPIRY_30_MINUTES, readCookie, setCookie} from '@Utils/cookie.util';
import {SUBSCRIPTION_PROMOTION_CODE_COOKIE} from '@Panels/premium-pricing-panel/premium-pricing-panel.types';
import {isUserPAYG} from '@Libraries/user.library';
import {isIOSApp} from '@Utils/browser.util';
import type {NewSubscriptionStartSource} from '@Libraries/ga-events';
import {NEW_SUBSCRIPTION_START_SOURCE_COOKIE} from '@Libraries/ga-events';

/**
 * An explicitly passed code takes precedence over the one a `?promo=` landing left behind, so a caller
 * that knows which offer it is upselling always wins over an older ambient cookie.
 */
const getPromoCodeToApply = (promoCode?: string): string => {
  if (promoCode !== undefined && promoCode !== '') {
    return promoCode;
  }

  return readCookie(SUBSCRIPTION_PROMOTION_CODE_COOKIE) ?? '';
};

export const canUserApplyPromoCode = (): boolean => {
  return !isIOSApp() && isUserPAYG();
};

export const openPremiumPricingModal = (isTrial: boolean, upsellFeatureName?: string, promoCode?: string, trialSource?: string): void => {
  const modalId = MODALS_IDS.PREMIUM_PRICING_MODAL;

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: modalId,
      panelProps: {
        modalId: modalId,
        isTrial: isTrial,
        upsellFeatureName: upsellFeatureName,
        promoCode: getPromoCodeToApply(promoCode),
        trialSource: trialSource,
      },
    })
  );
};

export const openPricingWithPromo = (source: NewSubscriptionStartSource, promoCode?: string): void => {
  setCookie(NEW_SUBSCRIPTION_START_SOURCE_COOKIE, source, COOKIE_EXPIRY_30_MINUTES);
  const isTrial = false;
  openPremiumPricingModal(isTrial, undefined, promoCode);
};
